/**
 * External Imports
 */
import { FC, useState } from 'react';

/**
 * Internal Imports
 */
import SideNav from '../../components/sideNav/adminSideNav/AdminSideNav';
import UnitsTable from '../../components/customTables/admin/areasTable/UnitsTable';
import DepartmentsTable from '../../components/customTables/admin/areasTable/DepartmentsTable';

import { useUserRolesRef } from '../../services/UserRoles';

/**
 * Style Imports
 */
import {
  AreasContainer,
  AreasContainerInner
} from './styles/AdminViews.styles';
import SearchHeader from '../../components/searchHeader';

const Areas: FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>('units');
  const [searchTerm, setSearchTerm] = useState<string>('');

  const { isEnterpriseAdmin } = useUserRolesRef();

  const menuItems = [
    { tabLabel: 'Units', tabId: 'units' },
    ...(isEnterpriseAdmin
      ? [{ tabLabel: 'CSC Departments', tabId: 'departments' }]
      : [])
  ];

  return (
    <AreasContainer data-testid="admin-area-list-view">
      <SideNav
        navItems={menuItems}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <AreasContainerInner>
        <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        {selectedTab && selectedTab === 'units' && (
          <UnitsTable searchTerm={searchTerm} />
        )}
        {selectedTab && selectedTab === 'departments' && (
          <DepartmentsTable searchTerm={searchTerm} />
        )}
      </AreasContainerInner>
    </AreasContainer>
  );
};

export default Areas;
